"use strict";
// API: https://developer.mozilla.org/en-US/docs/Web/API/FontFaceSet
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('pr.fontLoadingManager', function () {
        return {
            areFontsLoading: function () {
                return lodash_1.default.get(document, 'fonts.status') === 'loading';
            }
        };
    });
})(angular_1.module('qualtrics.pr'));
